// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"591":"f558f774","660":"c1735fa3","832":"d0f01a6a"}[chunkId] + ".css";
};